<template>
  <div
    v-on-click-outside="closeMenu"
    class="relative flex max-h-8 flex-1 flex-col rounded-full bg-gray-200"
  >
    <span
      v-show="value === 0"
      class="z-10 -mt-2 -mb-2-5 ml-2-5 w-min bg-white px-1-25 text-xs whitespace-nowrap text-gray-400"
    >
      {{ placeholder }}
    </span>
    <button
      type="button"
      class="relative h-11-5 w-full pr-8 pl-4 text-left text-headline capitalize focus:outline-hidden"
      @click.stop="toggleMenu"
    >
      <span class="text-xs font-semibold text-gray-500 uppercase">
        {{ Object.keys(options).length }} {{ placeholder }}
      </span>
      <span
        class="absolute inset-y-0 right-0 ml-3 flex cursor-pointer items-center pr-2"
      >
        <icon-chevron-up
          class="transform cursor-default transition-all"
          :class="{ 'rotate-180': !showMenu }"
        />
      </span>
    </button>
    <div v-show="showMenu" class="absolute top-9 left-0 h-full w-full">
      <ul
        tabindex="-1"
        class="absolute z-50 max-h-44 w-full overflow-y-auto rounded-md bg-white py-2 text-sm text-gray-500 shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm"
      >
        <li
          v-for="(option, idx) in options"
          :key="idx"
          class="flex justify-start overflow-auto py-2 hover:bg-gray-200"
          :aria-selected="isSelected(idx)"
          :class="{ 'bg-gray-100': isSelected(idx) }"
          @click="selectOption(idx)"
        >
          <span class="ml-3 cursor-pointer font-normal capitalize">
            {{ option }}
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";

import IconChevronUp from "@/components/icons/deals/IconChevronDown.vue";

export default {
  components: {
    IconChevronUp,
  },
  props: {
    options: Object,
    value: {
      type: [String, Number],
      default: "",
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  emits: ["change"],
  setup(props, { emit }) {
    const showMenu = ref(false);

    const selectOption = (option) => {
      if (typeof option === "string") {
        option = option.trimLeft();
      }
      toggleMenu();
      emit("change", option);
    };

    const toggleMenu = () => {
      showMenu.value = !showMenu.value;
    };

    const isSelected = (val) => {
      return typeof val === "string"
        ? val.trimLeft() == props.value
        : val == props.value;
    };

    const closeMenu = () => {
      showMenu.value = false;
    };

    return {
      showMenu,
      selectOption,
      toggleMenu,
      isSelected,
      closeMenu,
    };
  },
};
</script>
